'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userProviderDetails = require('./user-provider-details.html');

var _userProviderDetails2 = _interopRequireDefault(_userProviderDetails);

var _userProviderDetails3 = require('./user-provider-details.controller');

var _userProviderDetails4 = _interopRequireDefault(_userProviderDetails3);

require('./user-provider-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userProviderDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template: _userProviderDetails2.default,
  controller: _userProviderDetails4.default,
  controllerAs: 'vm'
};

exports.default = userProviderDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-provider-details/user-provider-details.component.js
 **/